import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2BuildingOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M19 2v9h8v15h-2V13h-8V4H7v24h6v-5h2v5h12l-1.4 2H5V2zM9 17h2v-2H9zm0-4h2v-2H9zm0-4h2V7H9zm4 8h2v-2h-2zm-4 4h2v-2H9zm4 0h2v-2h-2zm0-8h2v-2h-2zm0-4h2V7h-2zm4 16h2v-2h-2zm4 0h2v-2h-2zM9 25h2v-2H9zm8-4h2v-2h-2zm4 0h2v-2h-2zm-4-4h2v-2h-2zm4 0h2v-2h-2z" /></svg>
);
